import "@hotwired/turbo-rails";
import "../controllers";

// Web Awesome Pro, bundled by Vite from the npm package. `webawesome.js` is the
// core (utilities, theming, base classes) and registers no components on its
// own; the registrations come from webawesome_components.js, which imports all
// 87 statically so Vite can fingerprint them.
//
// This used to be a hardcoded `https://ka-p.webawesome.com/...` import, which
// Vite left external. Being a *static* import, it meant an unreachable CDN
// stopped this whole module from evaluating, taking Turbo and every Stimulus
// controller with it.
import { preventTurboFouce } from "@web.awesome.me/webawesome-pro/dist/webawesome.js";
import "../webawesome_components";

// Reproduces what the hosted kit used to inject. `utilities.css` also pulls in
// layers.css (the cascade-layer order) and fouce.css. `color/variants.css` is
// what defines the wa-brand-purple / wa-neutral-gray / wa-success-green /
// wa-warning-yellow / wa-danger-red classes the layouts put on <html>.
import "@web.awesome.me/webawesome-pro/dist/styles/native.css";
import "@web.awesome.me/webawesome-pro/dist/styles/utilities.css";
import "@web.awesome.me/webawesome-pro/dist/styles/color/palettes/mild.css";
import "@web.awesome.me/webawesome-pro/dist/styles/color/variants.css";
import "@web.awesome.me/webawesome-pro/dist/styles/themes/matter.css";

preventTurboFouce();
